
import { Locale, useI18n } from 'vue-i18n';
import { Ref } from 'vue';

export default {
  name: 'Footer',
  setup(): {
    t: (key: string) => string;
    locale: Ref<Locale>;
    availableLocales: Locale[];
    getDisplayName: (locale: string) => string;
  } {
    const { t, locale, availableLocales } = useI18n();

    const getDisplayName = (locale: string) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const nameGenerator = new Intl.DisplayNames(locale, { type: 'language' });
      return nameGenerator.of(locale) ?? locale;
    };

    return { t, locale, availableLocales, getDisplayName };
  },
};
